export default __webpack_public_path__ + "static/media/CF.2b9b2de4.png";